export const minValue = 1;
export const maxValue = 40;
